import { render, staticRenderFns } from "./Import_ticket.vue?vue&type=template&id=211aae6f&"
import script from "./Import_ticket.vue?vue&type=script&lang=js&"
export * from "./Import_ticket.vue?vue&type=script&lang=js&"
import style0 from "./Import_ticket.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports